<template lang="html">
  <section class="demo">

    <div style="width: 100%; display: flex; flex-direction: column;">
      <h3>SIP Support</h3>

      <div>
        For SIP calls support, we are currently mapping the user's mobile number in the following format:
      </div>

      <div class="Vlt-callout Vlt-callout--tip">
        +
        <span style="font-weight: bold;">
          MOBILE_NUMBER
        </span>
        @sip.linphone.org
      </div>

      <div>
        For example: +16501234567@sip.linphone.org
      </div>

      <div style="margin-top: 16px; margin-bottom: 16px;">
        <span style="color: #ff0000; font-style: italic;">
          Note: Currently we only supports linphone as the SIP provider.
        </span>
      </div>

    </div>

  </section>

</template>

<script lang="js">
  export default  {
    name: 'demo',
    components: {
    },
    props: {
      nexmo:{
          type: Object,
          required: false
      }
    },
}
</script>

<style scoped lang="scss">
</style>